<template>
  <img
    v-if="thumbnail"
    :src="'https://img.youtube.com/vi/' + youtubeCode + '/2.jpg'"
    :width="slotWidth"
    :height="slotHeight"
  />
  <div v-else class="videocontainer">
    <iframe
      :src="'https://www.youtube.com/embed/' + youtubeCode"
      frameborder="0"
      allowfullscreen
      class="video"
    ></iframe>
  </div>
</template>

<script>
export default {
  props: {
    youtubeCode: {
      type: String,
      required: true
    },
    slotWidth: {
      type: Number,
      required: true
    },
    slotHeight: {
      type: Number,
      required: true
    },
    thumbnail: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.videocontainer {
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;
}
.video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
